module.exports = __webpack_public_path__ + "img/wealthfooter.fd7f12ce.png";